/**
 * FullSend Header Scroll Observer
 * Toggles frosted-glass styling when user scrolls past the header.
 * The header is always position:fixed via CSS; this only adds the visual class.
 */
(function () {
  // Back-compat: a few templates (faq, bundle PDP) offset their own sticky
  // elements with these variables. The top bar is now a sticky block in
  // normal flow, so these no longer affect page layout — a late or missing
  // value is harmless, which is why this can live in a deferred script.
  function publishBarHeights() {
    var root = document.documentElement.style;
    var warn = document.querySelector('.nicotine-warning-bar');
    var ship = document.querySelector('.fs-shipbar');
    var bar = document.querySelector('[data-topbar]');
    root.setProperty('--nicotine-warning-height', (warn && warn.offsetParent ? warn.offsetHeight : 0) + 'px');
    root.setProperty('--fs-shipbar-height', (ship && ship.offsetParent ? ship.offsetHeight : 0) + 'px');
    root.setProperty('--fs-topbar-height', (bar ? bar.offsetHeight : 0) + 'px');
  }
  publishBarHeights();
  window.addEventListener('resize', publishBarHeights, { passive: true });
  if ('ResizeObserver' in window) {
    var ro = new ResizeObserver(publishBarHeights);
    document.querySelectorAll('.nicotine-warning-bar, .fs-shipbar, [data-header]').forEach(function (el) { ro.observe(el); });
  }

  var header = document.querySelector('[data-header]');
  if (!header) return;

  var isScrolled = false;
  var ticking = false;
  var threshold = 10;

  function update() {
    var scrollY = window.pageYOffset || document.documentElement.scrollTop;

    if (scrollY > threshold && !isScrolled) {
      isScrolled = true;
      header.classList.add('header--scrolled');
    } else if (scrollY <= threshold && isScrolled) {
      isScrolled = false;
      header.classList.remove('header--scrolled');
    }

    ticking = false;
  }

  function onScroll() {
    if (!ticking) {
      requestAnimationFrame(update);
      ticking = true;
    }
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  update();
})();
